const props = {
    "lastName" : "Gupta",
    "firstName" : "Rahul",
    "logoText" : "vTrack",
    "mainText" : "One stop shop for project management",
    "role" : "Admin"
};
 
export default props;